<div class="row align-items-center justify-content-center {{view_type}}" *ngIf="view_type === 'view1'">
    <ng-container *ngFor="let use_case of all_use_cases; let i = index">
        <div class="col-md-4 parent animated fadeIn delay-{{i}}">
            <div class="perfect-for-card">
                <img width="80" height="80" [src]="use_case.thumbnail" [alt]="use_case.title" />
                <div>
                    <h5 [innerHTML]="use_case.title"></h5>
                    <p [innerHTML]="use_case.description"></p>
                    <a [routerLink]="use_case.url" [class.disable-div]="isActivePage(use_case)"
                        *ngIf="use_case.url">Learn
                        more</a>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<div class="row justify-content-center {{view_type}}" *ngIf="view_type === 'view2'">
    <ng-container *ngFor="let use_case of all_use_cases; let i = index">
        <div class="col-md-6 parent animated fadeIn delay-{{i}}">
            <div class="perfect-for-card">
                <img width="50" height="50" [src]="use_case.thumbnail" [alt]="use_case.title" />
                <div>
                    <h5 class="mb-1" [innerHTML]="use_case.title"></h5>
                    <p [innerHTML]="use_case.description"></p>
                    <a [routerLink]="use_case.url" *ngIf="use_case.url">Learn
                        more
                        <i class="bi bi-arrow-right ms-1"></i>
                    </a>
                </div>
            </div>
        </div>
    </ng-container>
</div>